import { useMutation } from '@tanstack/react-query';
import { useDialogs, useNotifications } from '@toolpad/core';
import { useNavigate } from 'react-router';
import {
    Button,
    Card,
    CardContent,
    CardHeader,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Stack,
    Typography,
} from '@mui/material';

import Api from '@barboxx/api';
import { ProductCategory } from '@barboxx/models';
import { useBool } from '@barboxx/react-utils';

interface Props {
    productCategory: ProductCategory;
}

export const ProductCategoryDeleteCard = ({ productCategory }: Props) => {
    const notifications = useNotifications();
    const navigate = useNavigate();
    const [open, dialogActions] = useBool();
    const dialog = useDialogs();

    const mutateDeleteAlcohol = useMutation({
        mutationKey: ['deleteProductCategory', productCategory.id],
        mutationFn: () =>
            Api.Products.Categories.deleteProductCategory(productCategory),
    });

    const onDelete = async () => {
        const deleteConfirmed = await dialog.confirm(
            'Are you sure you want to Delete this product category!',
            {
                severity: 'error',
                okText: 'Delete',
                title: 'Delete product category',
            }
        );

        if (!deleteConfirmed) {
            return;
        }

        mutateDeleteAlcohol
            .mutateAsync()
            .then(({ data }) => {
                notifications.show('Deleted product category!', {
                    severity: 'success',
                });
                navigate('/products');
            })
            .catch(e => {
                notifications.show('Error Deleting product category!', {
                    severity: 'error',
                });
            });
    };

    return (
        <Card>
            <CardHeader title="Delete Alcohol Category" />
            <CardContent>
                <Stack gap={2} direction="row">
                    <Typography flex={1}>
                        Are you sure you want to Delete this product category
                        and all associated Brands with it?
                    </Typography>

                    <Button
                        onClick={dialogActions.on}
                        color="error"
                        variant="outlined"
                    >
                        Delete
                    </Button>
                </Stack>
            </CardContent>
            <Dialog
                open={open}
                onClose={dialogActions.off}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    Delete Alcohol
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to Delete this product!
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={dialogActions.off} color="inherit">
                        Cancel
                    </Button>

                    <Button
                        onClick={onDelete}
                        color="error"
                        variant="contained"
                        loading={mutateDeleteAlcohol.isPending}
                        autoFocus
                    >
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </Card>
    );
};
